/**
 * Which Algolia index holds GearFocus listings for the current deployment.
 *
 * Production indexes listings as `products`; every other environment
 * (preview, staging, local, CI) uses `listings`. Hardcoding `products` made
 * preview and staging deployments query PRODUCTION data — the bug this switch
 * was introduced to fix.
 *
 * Kept as a parameterised pure function, in its own UI-free module, for two
 * reasons: SearchBar and CategoryNav both need it and a duplicated inline
 * ternary is how the two drift apart, and a module-level `const X = env ===
 * 'production' ? …` is evaluated at import and can only be tested by resetting
 * the module registry. Both branches are directly assertable here.
 *
 * Note this is only the GearFocus app's listings index. The GearMaster app has
 * its own `products` index, which is not environment-switched and must not be
 * routed through this.
 */
export type GfListingsIndex = 'products' | 'listings';

export function gfListingsIndex(
  env: string | undefined = process.env.NEXT_PUBLIC_VERCEL_ENV
): GfListingsIndex {
  return env === 'production' ? 'products' : 'listings';
}
